import type { GattServer } from '@/ble/types';
import { tryGetChar, tryGetService } from '@/ble/gatt';
import { UUID } from '@/ble/uuids';

/** Battery Service level (0x180F / 0x2A19), or null if unavailable. */
export async function readBattery(server: GattServer): Promise<number | null> {
  const svc = await tryGetService(server, UUID.BAS);
  if (!svc) return null;
  const ch = await tryGetChar(svc, UUID.BATTERY_LEVEL);
  if (!ch) return null;
  try {
    const dv = await ch.readValue();
    return dv.byteLength > 0 ? dv.getUint8(0) : null;
  } catch {
    return null;
  }
}
